import api from "./api";

const CHANNEL_NAME = "rayna-rtk-cache-sync";

let channel: BroadcastChannel | null = null;

// Flag to prevent infinite loops - when we receive a broadcast and invalidate,
// we don't want to broadcast that invalidation back out
let isProcessingBroadcast = false;

export const isFromBroadcast = () => isProcessingBroadcast;

// Initialize the broadcast channel and listen for invalidation messages
export const setupCrossTabSync = (dispatch: any) => {
  // Check if BroadcastChannel is supported
  if (typeof BroadcastChannel === "undefined") {
    console.warn("BroadcastChannel not supported - cross-tab sync disabled");
    return;
  }

  channel = new BroadcastChannel(CHANNEL_NAME);

  // Listen for invalidation messages from other tabs
  channel.onmessage = (event) => {
    const { type, tags } = event.data;

    if (type === "INVALIDATE_TAGS" && Array.isArray(tags)) {
      // Set flag to prevent re-broadcasting
      isProcessingBroadcast = true;

      // Invalidate the specified tags in this tab's cache
      dispatch(api.util.invalidateTags(tags));

      // Reset flag after invalidation
      isProcessingBroadcast = false;
    }
  };
};

// Broadcast tag invalidation to other tabs
export const broadcastInvalidation = (
  tags: Array<{ type: string; id?: string }>
) => {
  if (channel) {
    channel.postMessage({ type: "INVALIDATE_TAGS", tags });
  }
};

// Cleanup on app unmount (optional)
export const closeCrossTabSync = () => {
  if (channel) {
    channel.close();
    channel = null;
  }
};
